import React, { useEffect } from 'react';
import './Contact.css';

const Contact = () => {
  useEffect(() => {
    // Redirigir a la página de contacto externa
    window.location.href = 'https://jpsicologo.com/contacto';
  }, []);
  
  return (
    <div className="contact-redirect">
      <div className="redirect-content">
        <div className="spinner"></div>
        <h2>Redirigiendo a la página de contacto...</h2>
        <p>Si no eres redirigido automáticamente, <a href="https://jpsicologo.com/contacto">haz clic aquí</a>.</p>
      </div>
    </div>
  );
};

export default Contact;
